var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('products-list',{staticClass:"col-max-width",attrs:{"fluid":""},on:{"back":_vm.onBackButton,"product-select":_vm.onProductSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }